import { formatTRY } from "@/lib/pricing";
import { Receipt } from "lucide-react";

export function CostPanel({ cost }) {
  return (
    <div className="card-atelier rounded-2xl p-6" data-testid="cost-panel">
      <div className="flex items-center gap-2 mb-4">
        <Receipt className="w-5 h-5 text-primary" />
        <h3 className="font-serif text-2xl font-bold text-stone-900">Maliyet Dökümü</h3>
      </div>

      <ul className="divide-y divide-[#E6DFD5]" data-testid="cost-itemized-list">
        {cost.items.filter((i) => !i.hidden).map((item, i) => (
          <li key={i} className="flex items-start justify-between py-2.5">
            <div>
              <p className="text-sm font-medium text-stone-800">{item.label}</p>
              <p className="text-xs text-stone-500 font-mono">{item.detail}</p>
            </div>
            <span className="text-sm font-semibold text-stone-900 whitespace-nowrap">
              {formatTRY(item.amount)}
            </span>
          </li>
        ))}
      </ul>

      <div className="mt-4 pt-4 border-t-2 border-primary/20 flex items-center justify-between">
        <span className="font-serif text-xl font-bold text-stone-900">Toplam Tutar</span>
        <span
          data-testid="cost-total-price"
          className="font-serif text-3xl font-bold text-primary"
        >
          {formatTRY(cost.total)}
        </span>
      </div>
      <p className="mt-2 text-xs text-stone-400">KDV dahil • Malzeme + kesim işçiliği • Montaj fiyata dahil değildir</p>
    </div>
  );
}
